import { Box } from '@hover/blueprint';
import { iFileText, iHome, iShoppingCart } from '@hover/icons';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import ActiveLockIcon from '../assets/svgs/ActiveLockIcon';

export const BETTER_WAY_TO_BUILD_CAROUSEL_DATA = [
  {
    img: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/contractor-screen1.png"
      />
    ),
    body: 'A contractor sent you a text. Follow the prompt and download the HOVER app.',
    index: 0,
  },
  {
    img: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/contractor-screen2.png"
      />
    ),
    body: 'Set up your account and secure it with a password.',
    index: 1,
  },
  {
    img: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/contractor-screen3.png"
      />
    ),
    body: 'Snap photos while walking around your home.',
    index: 2,
  },
  {
    img: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/contractor-screen4.png"
      />
    ),
    body: 'We notify you as soon as your 3D model is ready. (24-48 hours)',
    index: 3,
  },
  {
    img: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/contractor-screen5.png"
      />
    ),
    body: 'Visualize real products on your actual home in 3D using our Design Studio.',
    index: 4,
  },
  {
    img: (
      <Box mt="22px" className="last-item-margin">
        <StaticImage
          placeholder="blurred"
          width={378}
          objectFit="contain"
          alt="phone"
          src="../assets/images/invited_contractor.png"
        />
      </Box>
    ),
    body: 'Collaborate with your contractor to estimate costs.',
    index: 5,
  },
];

export const BETTER_WAY_TO_BUILD_CAROUSEL_DATA_MOBILE = [
  {
    img: (
      <StaticImage
        width={270}
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_text.png"
      />
    ),
    body: 'A contractor sent you a text. Follow the prompt and download the HOVER app.',
    index: 0,
  },
  {
    img: (
      <StaticImage
        width={270}
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_password.png"
      />
    ),
    body: 'Set up your account and secure it with a password.',
    index: 1,
  },
  {
    img: (
      <StaticImage
        width={270}
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_snap.png"
      />
    ),
    body: 'Snap photos while walking around your home.',
    index: 2,
  },
  {
    img: (
      <StaticImage
        width={270}
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_3d.png"
      />
    ),
    body: 'We notify you as soon as your 3D model is ready. (24-48 hours)',
    index: 3,
  },
  {
    img: (
      <StaticImage
        width={270}
        placeholder="blurred"
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_studio.png"
      />
    ),
    body: 'Visualize real products on your actual home in 3D using our Design Studio.',
    index: 4,
  },
  {
    img: (
      <Box mt="22px" justifyContent="center">
        <StaticImage
          placeholder="blurred"
          width={378}
          objectFit="contain"
          alt="phone"
          src="../assets/images/invited_contractor.png"
        />
      </Box>
    ),
    body: 'Collaborate with your contractor to estimate costs.',
    index: 5,
  },
];

export const INVITED_BY_CONTRACTOR_LIST_DATA = [
  {
    id: 0,
    title: 'PRIVACY MATTERS',
    body: 'You control access to your personal information, and you can remove access for any contractor or company.',
    icon: undefined,
    svgIcon: <ActiveLockIcon />,
    desktopImage: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
    mobileImage: (
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
  },
  {
    id: 1,
    title: 'VISUALIZE',
    body: 'No need to just guess what the finished product will look like—see it with your own eyes using our interactive, 3D design tools.',
    icon: iHome,
    svgIcon: undefined,
    desktopImage: (
      <StaticImage
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_group.png"
        objectFit="contain"
      />
    ),
    mobileImage: (
      <StaticImage
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_group_mobile.png"
        objectFit="contain"
      />
    ),
  },
  {
    id: 2,
    title: 'BETTER ESTIMATES',
    body: 'Fast, accurate measurements from your photos means a fast, more accurate estimate and fewer cost “uh-oh’s” later.',
    icon: iFileText,
    svgIcon: undefined,
    desktopImage: (
      <StaticImage
        placeholder="blurred"
        alt="take photo"
        objectFit="contain"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
    mobileImage: (
      <StaticImage
        placeholder="blurred"
        alt="take photo"
        objectFit="contain"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
  },
  {
    id: 3,
    title: 'TRANSPARENCY',
    body: 'Understand and trust your contractor’s proposal—no hidden costs or guesswork.',
    icon: iShoppingCart,
    svgIcon: undefined,
    desktopImage: null,
    mobileImage: null,
  },
];
